import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stepper,
  Step,
  StepLabel,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Card,
  CardContent,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Slider,
  Checkbox,
  FormControlLabel as MuiFormControlLabel,
  CircularProgress,
  IconButton,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Close,
  CheckCircle,
  Message,
  People,
  Schedule,
  Visibility,
  Assignment,
  Contacts,
  Label,
  Send,
  WatchLater,
  PlayArrow,
  Info,
  Phone,
  Link as LinkIcon,
  Reply,
  Code,
  List as ListIcon,
} from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  "@global": {
    "@keyframes slideIn": {
      from: {
        opacity: 0,
        transform: "translateY(-10px)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0)",
      },
    },
  },
  dialogPaper: {
    minHeight: "80vh",
    maxHeight: "90vh",
    maxWidth: "900px",
    [theme.breakpoints.down("md")]: {
      minHeight: "85vh",
      maxHeight: "95vh",
      margin: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "95vh",
      maxHeight: "98vh",
      margin: 0,
    },
  },
  stepper: {
    padding: theme.spacing(2, 0, 1.5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 0, 1),
      "& .MuiStepLabel-label": {
        fontSize: "0.75rem",
      },
      "& .MuiStepIcon-root": {
        fontSize: "1.2rem",
      },
    },
  },
  stepContent: {
    minHeight: "350px",
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      minHeight: "300px",
      padding: theme.spacing(1.5),
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "250px",
      padding: theme.spacing(1),
    },
  },
  previewBox: {
    backgroundColor: "#e5ddd5",
    padding: theme.spacing(2),
    borderRadius: 8,
    minHeight: 180,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
      minHeight: 150,
    },
  },
  previewMessage: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: theme.spacing(1.5),
  },
  previewButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    backgroundColor: "#f0f2f5",
    borderRadius: 4,
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#e4e6eb",
      transform: "scale(1.02)",
    },
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    whiteSpace: "pre-wrap",
    fontSize: "0.875rem",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      fontSize: "0.8rem",
    },
  },
  previewListMenu: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    backgroundColor: "#00a884",
    color: "#fff",
    borderRadius: 4,
    cursor: "pointer",
    fontWeight: 500,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#008f6f",
      transform: "scale(1.02)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      fontSize: "0.8rem",
    },
  },
  categoryChip: {
    position: "absolute",
    top: 8,
    right: 8,
    fontSize: "0.7rem",
    height: 24,
  },
  contactMethodCard: {
    cursor: "pointer",
    border: "2px solid #e0e0e0",
    transition: "all 0.3s",
    height: "100%",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      transform: "translateY(-2px)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    },
    [theme.breakpoints.down("sm")]: {
      "&:hover": {
        transform: "none",
      },
    },
  },
  selectedCard: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.selected,
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
  },
  scheduleTypeCard: {
    cursor: "pointer",
    border: "2px solid #e0e0e0",
    transition: "all 0.3s",
    textAlign: "center",
    padding: theme.spacing(3),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      transform: "translateY(-2px)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
      "&:hover": {
        transform: "none",
      },
    },
  },
  selectedScheduleCard: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.selected,
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
  },
}));

const steps = ["Informações", "Mensagem", "Contatos", "Agendamento", "Revisão"];

const OfficialCampaignModal = ({ open, onClose, onSave }) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);

  // Step 1: Informações
  const [campaignName, setCampaignName] = useState("");
  const [selectedConnection, setSelectedConnection] = useState("");
  const [connections, setConnections] = useState([]);

  // Step 2: Mensagem/Template
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [templateSearch, setTemplateSearch] = useState("");

  // Step 3: Contatos
  const [contactMethod, setContactMethod] = useState("paste"); // paste, system, tags
  const [pastedNumbers, setPastedNumbers] = useState("");
  const [processedNumbers, setProcessedNumbers] = useState([]);
  const [contactLists, setContactLists] = useState([]);
  const [selectedContactList, setSelectedContactList] = useState("");
  const [tagLists, setTagLists] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  // Step 4: Agendamento
  const [scheduleType, setScheduleType] = useState("immediate"); // immediate, scheduled
  const [scheduledDate, setScheduledDate] = useState("");
  const [scheduledTime, setScheduledTime] = useState("");
  const [messageInterval, setMessageInterval] = useState(60);
  const [createTicket, setCreateTicket] = useState(false);
  const [showAllButtons, setShowAllButtons] = useState(false);

  useEffect(() => {
    if (open) {
      loadConnections();
      loadContactLists();
      loadTags();
    }
  }, [open]);

  useEffect(() => {
    if (selectedConnection) {
      loadTemplates();
    }
  }, [selectedConnection]);

  const loadConnections = async () => {
    try {
      const { data } = await api.get("/whatsapp", {
        params: { companyId: user.companyId, session: 0 },
      });
      const officialConnections = data.filter(
        (w) => w.channel === "whatsapp_oficial" && w.status === "CONNECTED"
      );
      setConnections(officialConnections);
    } catch (err) {
      console.error("Erro ao carregar conexões:", err);
      toast.error("Erro ao carregar conexões");
    }
  };

  const loadTemplates = async () => {
    setLoadingTemplates(true);
    try {
      const connection = connections.find((c) => c.id === selectedConnection);
      const { data } = await api.get("/whatsapp-templates", {
        params: {
          searchParam: "",
          statusFilter: "APPROVED",
          channelFilter: connection?.name || "",
          all: true, // Buscar TODOS os templates sem paginação
        },
      });
      
      // Parse buttons se vier como string JSON e extrair de components se necessário
      const parsedTemplates = (data.templates || []).map(template => {
        let buttons = template.buttons;
        
        // Se buttons for string, fazer parse
        if (buttons && typeof buttons === 'string') {
          try {
            buttons = JSON.parse(buttons);
          } catch (e) {
            console.error("Erro ao fazer parse dos botões:", e);
            buttons = null;
          }
        }
        
        // Se não tiver buttons mas tiver components, extrair botões dos components
        if ((!buttons || buttons.length === 0) && template.components) {
          try {
            const components = typeof template.components === 'string' 
              ? JSON.parse(template.components) 
              : template.components;
            
            const buttonComponent = components.find(c => c.type === 'BUTTONS');
            if (buttonComponent && buttonComponent.buttons) {
              buttons = buttonComponent.buttons;
            }
          } catch (e) {
            console.error("Erro ao extrair botões dos components:", e);
          }
        }
        
        return { ...template, buttons: buttons || [] };
      });
      
      console.log("Templates carregados:", parsedTemplates);
      setTemplates(parsedTemplates);
    } catch (err) {
      console.error("Erro ao carregar templates:", err);
      toast.error("Erro ao carregar templates");
    } finally {
      setLoadingTemplates(false);
    }
  };

  const loadContactLists = async () => {
    try {
      const { data } = await api.get("/contact-lists/list", {
        params: { companyId: user.companyId },
      });
      setContactLists(data);
    } catch (err) {
      console.error("Erro ao carregar listas de contatos:", err);
    }
  };

  const loadTags = async () => {
    try {
      const { data } = await api.get("/tags/list", {
        params: { companyId: user.companyId, kanban: 0 },
      });
      const formattedTags = data
        .filter((tag) => tag.contacts.length > 0)
        .map((tag) => ({
          id: tag.id,
          name: `${tag.name} (${tag.contacts.length})`,
        }));
      setTagLists(formattedTags);
    } catch (err) {
      console.error("Erro ao carregar tags:", err);
    }
  };

  const processNumbers = () => {
    const numbers = pastedNumbers
      .split("\n")
      .map((num) => num.trim())
      .filter((num) => num.length > 0)
      .map((num) => {
        // Remove caracteres não numéricos
        let cleaned = num.replace(/\D/g, "");
        
        // Adiciona código do país se não tiver
        if (!cleaned.startsWith("55")) {
          cleaned = "55" + cleaned;
        }
        
        // Adiciona o 9 se necessário (celular brasileiro)
        if (cleaned.length === 12 && cleaned.startsWith("55")) {
          const ddd = cleaned.substring(2, 4);
          const number = cleaned.substring(4);
          if (!number.startsWith("9")) {
            cleaned = "55" + ddd + "9" + number;
          }
        }
        
        return cleaned;
      });

    const unique = [...new Set(numbers)];
    setProcessedNumbers(unique);
    toast.success(`${unique.length} números processados com sucesso!`);
  };

  const handleNext = () => {
    // Validações por step
    if (activeStep === 0) {
      if (!campaignName || !selectedConnection) {
        toast.warning("Preencha todos os campos obrigatórios");
        return;
      }
    }
    if (activeStep === 1) {
      if (!selectedTemplate) {
        toast.warning("Selecione um template");
        return;
      }
    }
    if (activeStep === 2) {
      if (contactMethod === "paste" && processedNumbers.length === 0) {
        toast.warning("Processe os números antes de continuar");
        return;
      }
      if (contactMethod === "system" && !selectedContactList) {
        toast.warning("Selecione uma lista de contatos");
        return;
      }
      if (contactMethod === "tags" && selectedTags.length === 0) {
        toast.warning("Selecione pelo menos uma tag");
        return;
      }
    }
    if (activeStep === 3) {
      if (scheduleType === "scheduled" && (!scheduledDate || !scheduledTime)) {
        toast.warning("Defina data e hora para o agendamento");
        return;
      }
    }

    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const campaignData = {
        name: campaignName,
        whatsappId: selectedConnection,
        templateId: selectedTemplate.id,
        contactMethod,
        contacts: contactMethod === "paste" ? processedNumbers : null,
        contactListId: contactMethod === "system" ? selectedContactList : null,
        tagIds: contactMethod === "tags" ? selectedTags : null,
        scheduleType,
        scheduledDate: scheduleType === "scheduled" ? scheduledDate : null,
        scheduledTime: scheduleType === "scheduled" ? scheduledTime : null,
        messageInterval,
        createTicket,
        companyId: user.companyId,
      };

      await api.post("/official-campaigns", campaignData);
      toast.success("Campanha criada com sucesso!");
      onSave();
      handleClose();
    } catch (err) {
      console.error("Erro ao criar campanha:", err);
      toast.error(err.response?.data?.error || "Erro ao criar campanha");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setActiveStep(0);
    setCampaignName("");
    setSelectedConnection("");
    setSelectedTemplate(null);
    setContactMethod("paste");
    setPastedNumbers("");
    setProcessedNumbers([]);
    setSelectedContactList("");
    setSelectedTags([]);
    setScheduleType("immediate");
    setScheduledDate("");
    setScheduledTime("");
    setMessageInterval(60);
    setCreateTicket(false);
    onClose();
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return renderInformationStep();
      case 1:
        return renderMessageStep();
      case 2:
        return renderContactsStep();
      case 3:
        return renderScheduleStep();
      case 4:
        return renderReviewStep();
      default:
        return null;
    }
  };

  const renderInformationStep = () => (
    <Box className={classes.stepContent}>
      <Box display="flex" alignItems="center" mb={2}>
        <Info color="primary" style={{ marginRight: 8, fontSize: 20 }} />
        <Typography variant="h6" style={{ fontSize: "1rem", fontWeight: 600 }}>Informações Básicas</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Nome da Campanha"
            fullWidth
            required
            variant="outlined"
            size="small"
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
            placeholder="Ex: Campanha Black Friday 2025"
            helperText="Escolha um nome descritivo para identificar sua campanha"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth required variant="outlined" size="small">
            <InputLabel>Conexão WhatsApp Oficial</InputLabel>
            <Select
              value={selectedConnection}
              onChange={(e) => setSelectedConnection(e.target.value)}
              label="Conexão WhatsApp Oficial"
            >
              {connections.length === 0 ? (
                <MenuItem value="" disabled>
                  Nenhuma conexão oficial disponível
                </MenuItem>
              ) : (
                connections.map((conn) => (
                  <MenuItem key={conn.id} value={conn.id}>
                    {conn.name} ✓
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: "block" }}>
            Selecione a conexão WhatsApp Business API que será usada para enviar as mensagens
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  // Função para destacar variáveis no texto
  const highlightVariables = (text) => {
    if (!text) return text;
    
    // Regex para encontrar {{variavel}}
    const regex = /\{\{(nome|email|campo[1-5]|\d+)\}\}/gi;
    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = regex.exec(text)) !== null) {
      // Adicionar texto antes da variável
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }
      
      // Adicionar variável destacada
      parts.push(
        <span 
          key={`var-${key++}`}
          style={{ 
            backgroundColor: '#e3f2fd', 
            color: '#1976d2', 
            padding: '2px 6px',
            borderRadius: 4,
            fontWeight: 600,
            fontSize: '0.875rem'
          }}
        >
          {match[0]}
        </span>
      );
      
      lastIndex = regex.lastIndex;
    }
    
    // Adicionar texto restante
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }
    
    return parts.length > 0 ? parts : text;
  };

  const renderMessageStep = () => {
    // Filtrar templates baseado na pesquisa
    const filteredTemplates = templates.filter((template) =>
      template.name.toLowerCase().includes(templateSearch.toLowerCase()) ||
      template.category.toLowerCase().includes(templateSearch.toLowerCase())
    );

    return (
      <Box className={classes.stepContent}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={1.5}>
              <Message color="primary" style={{ marginRight: 8, fontSize: 20 }} />
              <Typography variant="h6" style={{ fontSize: "0.95rem", fontWeight: 600 }}>Selecione o Template</Typography>
            </Box>
            
            {/* Campo de Pesquisa */}
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="🔍 Pesquisar templates por nome ou categoria..."
              value={templateSearch}
              onChange={(e) => setTemplateSearch(e.target.value)}
              style={{ marginBottom: 12 }}
              disabled={loadingTemplates}
            />

            {/* Lista de Templates Interativa */}
            <Box 
              style={{ 
                maxHeight: 320, 
                overflowY: 'auto',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                backgroundColor: '#fafafa'
              }}
            >
              {filteredTemplates.length === 0 && !loadingTemplates && (
                <Box p={3} textAlign="center">
                  <Typography variant="body2" color="textSecondary">
                    {templateSearch ? 'Nenhum template encontrado' : 'Nenhum template disponível'}
                  </Typography>
                </Box>
              )}
              
              {filteredTemplates.map((template) => (
                <Card
                  key={template.id}
                  onClick={() => setSelectedTemplate(template)}
                  style={{
                    margin: 8,
                    cursor: 'pointer',
                    border: selectedTemplate?.id === template.id ? '2px solid #25D366' : '1px solid #e0e0e0',
                    backgroundColor: selectedTemplate?.id === template.id ? '#e8f5e9' : '#fff',
                    transition: 'all 0.2s ease',
                    position: 'relative'
                  }}
                  elevation={selectedTemplate?.id === template.id ? 3 : 1}
                  onMouseEnter={(e) => {
                    if (selectedTemplate?.id !== template.id) {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    if (selectedTemplate?.id !== template.id) {
                      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
                    }
                  }}
                >
                  <CardContent style={{ padding: 12, paddingBottom: '12px !important' }}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                      <Box flex={1}>
                        <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
                          {template.name}
                        </Typography>
                        <Box display="flex" gap={0.5} alignItems="center" flexWrap="wrap">
                          <Chip 
                            label={template.category} 
                            size="small" 
                            style={{ 
                              height: 20, 
                              fontSize: '0.7rem',
                              backgroundColor: '#e3f2fd',
                              color: '#1976d2'
                            }} 
                          />
                          <Chip 
                            label={template.language} 
                            size="small" 
                            style={{ 
                              height: 20, 
                              fontSize: '0.7rem',
                              backgroundColor: '#f3e5f5',
                              color: '#7b1fa2'
                            }} 
                          />
                        </Box>
                      </Box>
                      {selectedTemplate?.id === template.id && (
                        <CheckCircle style={{ color: '#25D366', fontSize: 20 }} />
                      )}
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
            
            {/* Contador de templates */}
            <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: "block" }}>
              {filteredTemplates.length} de {templates.length} template(s)
            </Typography>
          {loadingTemplates && (
            <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
              <CircularProgress size={24} style={{ marginRight: 8 }} />
              <Typography variant="caption">Carregando templates...</Typography>
            </Box>
          )}
          {!loadingTemplates && templates.length === 0 && (
            <Typography variant="caption" color="error" style={{ marginTop: 8, display: "block" }}>
              Nenhum template aprovado encontrado para esta conexão
            </Typography>
          )}
          </Grid>
          <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" mb={1.5}>
            <Visibility color="primary" style={{ marginRight: 8, fontSize: 20 }} />
            <Typography variant="h6" style={{ fontSize: "0.95rem", fontWeight: 600 }}>Pré-visualização</Typography>
            {selectedTemplate && (
              <Chip
                label={selectedTemplate.category}
                size="small"
                color="primary"
                style={{ marginLeft: 8 }}
              />
            )}
          </Box>
          <Box className={classes.previewBox}>
            {selectedTemplate ? (
              <Box className={classes.previewMessage}>
                {selectedTemplate.headerText && (
                  <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8 }}>
                    {highlightVariables(selectedTemplate.headerText)}
                  </Typography>
                )}
                <Typography variant="body2">{highlightVariables(selectedTemplate.bodyText)}</Typography>
                {selectedTemplate.footerText && (
                  <Typography
                    variant="caption"
                    style={{ display: "block", marginTop: 8, color: "#666" }}
                  >
                    {selectedTemplate.footerText}
                  </Typography>
                )}
                {selectedTemplate.buttons && selectedTemplate.buttons.length > 0 && (
                  <Box mt={1}>
                    {selectedTemplate.buttons.length > 3 && !showAllButtons ? (
                      // Menu lista quando mais de 3 botões (colapsado)
                      <Box 
                        className={classes.previewListMenu}
                        onClick={() => setShowAllButtons(true)}
                      >
                        <ListIcon style={{ fontSize: 18 }} />
                        <span style={{ fontWeight: 600 }}>Ver {selectedTemplate.buttons.length} opções</span>
                      </Box>
                    ) : (
                      // Botões expandidos
                      <>
                        {selectedTemplate.buttons.map((button, index) => (
                          <Box 
                            key={index} 
                            className={classes.previewButton}
                            style={{
                              animation: showAllButtons ? `slideIn 0.3s ease ${index * 0.05}s both` : 'none'
                            }}
                          >
                            {button.type === "PHONE_NUMBER" && <Phone style={{ fontSize: 16 }} />}
                            {button.type === "URL" && <LinkIcon style={{ fontSize: 16 }} />}
                            {button.type === "QUICK_REPLY" && <Reply style={{ fontSize: 16 }} />}
                            {button.type === "COPY_CODE" && <Code style={{ fontSize: 16 }} />}
                            <span style={{ color: "#0088cc" }}>{button.text || "Botão"}</span>
                          </Box>
                        ))}
                        {selectedTemplate.buttons.length > 3 && showAllButtons && (
                          <Box 
                            className={classes.previewButton}
                            onClick={() => setShowAllButtons(false)}
                            style={{ backgroundColor: "#e4e6eb", marginTop: 8 }}
                          >
                            <Close style={{ fontSize: 16 }} />
                            <span style={{ fontSize: "0.875rem" }}>Fechar</span>
                          </Box>
                        )}
                      </>
                    )}
                  </Box>
                )}
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={200}>
                <Message style={{ fontSize: 48, color: "#ccc", marginBottom: 16 }} />
                <Typography variant="body2" color="textSecondary" align="center">
                  Selecione um template para visualizar
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
    );
  };

  const renderContactsStep = () => (
    <Box className={classes.stepContent}>
      <Box display="flex" alignItems="center" mb={2}>
        <People color="primary" style={{ marginRight: 8, fontSize: 20 }} />
        <Typography variant="h6" style={{ fontSize: "1rem", fontWeight: 600 }}>Selecione os Contatos</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card
            className={`${classes.contactMethodCard} ${
              contactMethod === "paste" ? classes.selectedCard : ""
            }`}
            onClick={() => setContactMethod("paste")}
          >
            <CardContent style={{ textAlign: "center", padding: 16 }}>
              <Assignment style={{ fontSize: 32 }} color={contactMethod === "paste" ? "primary" : "inherit"} />
              <Typography variant="subtitle1" style={{ marginTop: 8, fontSize: "0.9rem", fontWeight: 600 }}>Copiar e Colar</Typography>
              <Typography variant="caption" color="textSecondary" style={{ fontSize: "0.75rem" }}>Cole os números de telefone</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            className={`${classes.contactMethodCard} ${
              contactMethod === "system" ? classes.selectedCard : ""
            }`}
            onClick={() => setContactMethod("system")}
          >
            <CardContent style={{ textAlign: "center", padding: 16 }}>
              <Contacts style={{ fontSize: 32 }} color={contactMethod === "system" ? "primary" : "inherit"} />
              <Typography variant="subtitle1" style={{ marginTop: 8, fontSize: "0.9rem", fontWeight: 600 }}>Contatos do Sistema</Typography>
              <Typography variant="caption" color="textSecondary" style={{ fontSize: "0.75rem" }}>Selecione contatos cadastrados</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            className={`${classes.contactMethodCard} ${
              contactMethod === "tags" ? classes.selectedCard : ""
            }`}
            onClick={() => setContactMethod("tags")}
          >
            <CardContent style={{ textAlign: "center", padding: 16 }}>
              <Label style={{ fontSize: 32 }} color={contactMethod === "tags" ? "primary" : "inherit"} />
              <Typography variant="subtitle1" style={{ marginTop: 8, fontSize: "0.9rem", fontWeight: 600 }}>Tags</Typography>
              <Typography variant="caption" color="textSecondary" style={{ fontSize: "0.75rem" }}>Selecione por tags</Typography>
            </CardContent>
          </Card>
        </Grid>

        {contactMethod === "paste" && (
          <Grid item xs={12}>
            <TextField
              label="Cole os números de telefone (um por linha)"
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              size="small"
              value={pastedNumbers}
              onChange={(e) => setPastedNumbers(e.target.value)}
              placeholder="81999960618&#10;71987654321&#10;11912345678"
            />
            <Box mt={1.5} display="flex" justifyContent="space-between" alignItems="center">
              <Button variant="contained" color="primary" size="small" onClick={processNumbers}>
                ✓ Processar Contatos
              </Button>
              {processedNumbers.length > 0 && (
                <Chip
                  label={`${processedNumbers.length} números processados`}
                  color="primary"
                />
              )}
            </Box>
          </Grid>
        )}

        {contactMethod === "system" && (
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Lista de Contatos</InputLabel>
              <Select
                value={selectedContactList}
                onChange={(e) => setSelectedContactList(e.target.value)}
                label="Lista de Contatos"
              >
                {contactLists.map((list) => (
                  <MenuItem key={list.id} value={list.id}>
                    {list.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {contactMethod === "tags" && (
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Tags</InputLabel>
              <Select
                multiple
                value={selectedTags}
                onChange={(e) => setSelectedTags(e.target.value)}
                label="Tags"
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={tagLists.find((t) => t.id === value)?.name}
                        size="small"
                      />
                    ))}
                  </Box>
                )}
              >
                {tagLists.map((tag) => (
                  <MenuItem key={tag.id} value={tag.id}>
                    {tag.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </Box>
  );

  const renderScheduleStep = () => (
    <Box className={classes.stepContent}>
      <Box display="flex" alignItems="center" mb={2}>
        <Schedule color="primary" style={{ marginRight: 8, fontSize: 20 }} />
        <Typography variant="h6" style={{ fontSize: "1rem", fontWeight: 600 }}>Agendamento da Campanha</Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" gutterBottom style={{ fontSize: "0.875rem" }}>
            Tipo de Agendamento
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            className={`${classes.scheduleTypeCard} ${
              scheduleType === "immediate" ? classes.selectedScheduleCard : ""
            }`}
            onClick={() => setScheduleType("immediate")}
          >
            <PlayArrow color={scheduleType === "immediate" ? "primary" : "inherit"} style={{ fontSize: 40 }} />
            <Typography variant="subtitle1" style={{ marginTop: 8, fontSize: "0.9rem", fontWeight: 600 }}>Envio Imediato</Typography>
            <Typography variant="caption" color="textSecondary" style={{ fontSize: "0.75rem" }}>Enviar assim que finalizar</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            className={`${classes.scheduleTypeCard} ${
              scheduleType === "scheduled" ? classes.selectedScheduleCard : ""
            }`}
            onClick={() => setScheduleType("scheduled")}
          >
            <WatchLater color={scheduleType === "scheduled" ? "primary" : "inherit"} style={{ fontSize: 40 }} />
            <Typography variant="subtitle1" style={{ marginTop: 8, fontSize: "0.9rem", fontWeight: 600 }}>Agendar</Typography>
            <Typography variant="caption" color="textSecondary" style={{ fontSize: "0.75rem" }}>Definir data e hora</Typography>
          </Card>
        </Grid>

        {scheduleType === "scheduled" && (
          <>
            <Grid item xs={12} md={6}>
              <TextField
                label="Data do Envio"
                type="date"
                fullWidth
                required
                variant="outlined"
                size="small"
                value={scheduledDate}
                onChange={(e) => setScheduledDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: moment().format("YYYY-MM-DD") }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Hora do Envio"
                type="time"
                fullWidth
                required
                variant="outlined"
                size="small"
                value={scheduledTime}
                onChange={(e) => setScheduledTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          <Divider style={{ margin: "16px 0" }} />
          <Typography variant="subtitle2" gutterBottom>
            Configurações
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography gutterBottom>
            Intervalo entre mensagens: {messageInterval} segundos
          </Typography>
          <Slider
            value={messageInterval}
            onChange={(e, newValue) => setMessageInterval(newValue)}
            min={0}
            max={300}
            step={10}
            marks={[
              { value: 0, label: "0s" },
              { value: 60, label: "60s" },
              { value: 120, label: "120s" },
              { value: 180, label: "180s" },
              { value: 240, label: "240s" },
              { value: 300, label: "300s" },
            ]}
            valueLabelDisplay="auto"
          />
          <Typography variant="caption" color="textSecondary">
            Intervalo mínimo: 0 segundos
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <MuiFormControlLabel
            control={
              <Checkbox
                checked={createTicket}
                onChange={(e) => setCreateTicket(e.target.checked)}
                color="primary"
              />
            }
            label="Criar ticket ao enviar a mensagem da campanha"
          />
          <Typography variant="caption" color="textSecondary" display="block">
            Se ativado, um ticket será criado automaticamente ao enviar a mensagem da campanha
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  const renderReviewStep = () => (
    <Box className={classes.stepContent}>
      <Box display="flex" alignItems="center" mb={2}>
        <CheckCircle color="primary" style={{ marginRight: 8, fontSize: 20 }} />
        <Typography variant="h6" style={{ fontSize: "1rem", fontWeight: 600 }}>Revisão Final</Typography>
      </Box>
      <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
        Revise todas as informações antes de criar a campanha
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Informações da Campanha
              </Typography>
              <Typography variant="body2">
                <strong>Nome:</strong> {campaignName}
              </Typography>
              <Typography variant="body2">
                <strong>Conexão:</strong>{" "}
                {connections.find((c) => c.id === selectedConnection)?.name}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Template Selecionado
              </Typography>
              <Typography variant="body2">
                <strong>Nome:</strong> {selectedTemplate?.name}
              </Typography>
              <Typography variant="body2">
                <strong>Categoria:</strong> {selectedTemplate?.category}
              </Typography>
              <Box mt={2} className={classes.previewMessage}>
                {selectedTemplate?.headerText && (
                  <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8 }}>
                    {highlightVariables(selectedTemplate.headerText)}
                  </Typography>
                )}
                <Typography variant="body2">{highlightVariables(selectedTemplate?.bodyText)}</Typography>
                {selectedTemplate?.footerText && (
                  <Typography
                    variant="caption"
                    style={{ display: "block", marginTop: 8, color: "#666" }}
                  >
                    {selectedTemplate.footerText}
                  </Typography>
                )}
                {selectedTemplate?.buttons && selectedTemplate.buttons.length > 0 && (
                  <Box mt={1}>
                    {selectedTemplate.buttons.length > 3 ? (
                      // Menu lista quando mais de 3 botões
                      <Box className={classes.previewListMenu}>
                        <ListIcon style={{ fontSize: 18 }} />
                        <span style={{ fontWeight: 600 }}>Ver {selectedTemplate.buttons.length} opções</span>
                      </Box>
                    ) : (
                      // Botões normais quando 3 ou menos
                      selectedTemplate.buttons.map((button, index) => (
                        <Box 
                          key={index} 
                          className={classes.previewButton}
                        >
                          {button.type === "PHONE_NUMBER" && <Phone style={{ fontSize: 16 }} />}
                          {button.type === "URL" && <LinkIcon style={{ fontSize: 16 }} />}
                          {button.type === "QUICK_REPLY" && <Reply style={{ fontSize: 16 }} />}
                          {button.type === "COPY_CODE" && <Code style={{ fontSize: 16 }} />}
                          <span style={{ color: "#0088cc" }}>{button.text || "Botão"}</span>
                        </Box>
                      ))
                    )}
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Contatos
              </Typography>
              {contactMethod === "paste" && (
                <Typography variant="body2">
                  <strong>Método:</strong> Números colados ({processedNumbers.length} contatos)
                </Typography>
              )}
              {contactMethod === "system" && (
                <>
                  <Typography variant="body2">
                    <strong>Método:</strong> Lista do sistema (
                    {contactLists.find((l) => l.id === selectedContactList)?.name})
                  </Typography>
                  <Box mt={1} p={1} style={{ backgroundColor: '#e3f2fd', borderRadius: 4 }}>
                    <Typography variant="caption" color="textSecondary">
                      💡 As variáveis <strong>{"{{nome}}"}</strong>, <strong>{"{{email}}"}</strong>, <strong>{"{{campo1}}"}</strong> até <strong>{"{{campo5}}"}</strong> serão substituídas pelos dados de cada contato da lista.
                    </Typography>
                  </Box>
                </>
              )}
              {contactMethod === "tags" && (
                <Typography variant="body2">
                  <strong>Método:</strong> Tags ({selectedTags.length} selecionadas)
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Agendamento
              </Typography>
              {scheduleType === "immediate" ? (
                <Typography variant="body2">
                  <strong>Tipo:</strong> Envio Imediato
                </Typography>
              ) : (
                <>
                  <Typography variant="body2">
                    <strong>Tipo:</strong> Agendado
                  </Typography>
                  <Typography variant="body2">
                    <strong>Data:</strong> {moment(scheduledDate).format("DD/MM/YYYY")}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Hora:</strong> {scheduledTime}
                  </Typography>
                </>
              )}
              <Typography variant="body2">
                <strong>Intervalo entre mensagens:</strong> {messageInterval} segundos
              </Typography>
              <Typography variant="body2">
                <strong>Criar ticket:</strong> {createTicket ? "Sim" : "Não"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1rem" }}>
            Criar Campanha com API Oficial
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            size="small"
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {renderStepContent()}
      </DialogContent>

      <DialogActions style={{ padding: "16px 24px" }}>
        <Button onClick={handleClose} color="default">
          Cancelar
        </Button>
        <Box flex={1} />
        {activeStep > 0 && (
          <Button onClick={handleBack} color="primary">
            Voltar
          </Button>
        )}
        {activeStep < steps.length - 1 ? (
          <Button onClick={handleNext} color="primary" variant="contained" size="medium">
            Continuar
          </Button>
        ) : (
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            size="medium"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={18} /> : <Send />}
          >
            {loading ? "Enviando..." : "Criar Campanha"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default OfficialCampaignModal;
